// extracted by mini-css-extract-plugin
export default {"title":"e17bb755a2","bld":"_8611224218"};